/**
 * Stock Transfer API Client
 * Frontend API calls for inter-branch stock transfers
 */

import apiClient from './client';

/**
 * Get all transfers with filters
 */
export const getTransfers = async (params = {}) => {
  const response = await apiClient.get('/stock-transfers', { params });
  return response.data;
};

/**
 * Get single transfer by ID
 */
export const getTransferById = async (id) => {
  const response = await apiClient.get(`/stock-transfers/${id}`);
  return response.data;
};

/**
 * Create a new transfer
 */
export const createTransfer = async (data) => {
  const response = await apiClient.post('/stock-transfers', data);
  return response.data;
};

/**
 * Approve a transfer
 */
export const approveTransfer = async (id) => {
  const response = await apiClient.put(`/stock-transfers/${id}/approve`);
  return response.data;
};

/**
 * Reject a transfer
 */
export const rejectTransfer = async (id, reason) => {
  const response = await apiClient.put(`/stock-transfers/${id}/reject`, { reason });
  return response.data;
};

/**
 * Ship a transfer
 */
export const shipTransfer = async (id, items, trackingReference = null) => {
  const response = await apiClient.put(`/stock-transfers/${id}/ship`, {
    items,
    trackingReference
  });
  return response.data;
};

/**
 * Receive a transfer (full or partial)
 */
export const receiveTransfer = async (id, items) => {
  const response = await apiClient.put(`/stock-transfers/${id}/receive`, { items });
  return response.data;
};

/**
 * Cancel a transfer
 */
export const cancelTransfer = async (id, reason) => {
  const response = await apiClient.put(`/stock-transfers/${id}/cancel`, { reason });
  return response.data;
};

/**
 * Get pending approval count (for notifications)
 */
export const getPendingApprovalCount = async () => {
  const response = await apiClient.get('/stock-transfers/pending-count');
  return response.data;
};

export default {
  getTransfers,
  getTransferById,
  createTransfer,
  approveTransfer,
  rejectTransfer,
  shipTransfer,
  receiveTransfer,
  cancelTransfer,
  getPendingApprovalCount
};
